import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { USER_KEY } from '@teetsh/app/src/queries/user/useUser';
import { USER_ACCOUNT_KEY } from '@teetsh/app/src/queries/user/account/useUserAccount';
import { ReasonToCancelType } from '@teetsh/app/src/containers/UserSettings/Souscription/Cancel/CancelSteps/reasonsToCancel';
import { BILLING_INFO_KEY } from '@teetsh/app/src/queries/useBillingInfos';
import { useTranslation } from 'react-i18next';

interface Props {
  cancelReason?: ReasonToCancelType;
  cancelReasonDetails?: string;
  otherToolDetail?: string;
}

export default function useCancelSubscription() {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['userSettings']);
  const { notifyError } = useNotification();
  const { mutateAsync } = useMutation({
    mutationFn: (p: Props) =>
      request('/billing/cancel', {
        method: 'DELETE',
        body: p,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [BILLING_INFO_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [USER_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [USER_ACCOUNT_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('userSettings:notifications.subscriptionCancelError'),
      });
    },
  });
  return mutateAsync;
}
